/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TabsWaiterRouteImport } from './routes/tabs-waiter'
import { Route as TabsHistoryRouteImport } from './routes/tabs-history'
import { Route as TabsAdminRouteImport } from './routes/tabs-admin'
import { Route as TabRouteImport } from './routes/tab'
import { Route as SellRouteImport } from './routes/sell'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as ReceiptsRouteImport } from './routes/receipts'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as CashbookRouteImport } from './routes/cashbook'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsClosedRouteImport } from './routes/reports.closed'
import { Route as ReportsCashbookRouteImport } from './routes/reports.cashbook'
import { Route as ReceiptIdRouteImport } from './routes/receipt.$id'
import { Route as CashbookNewRouteImport } from './routes/cashbook.new'
import { Route as CashbookCloseRouteImport } from './routes/cashbook.close'
import { Route as ReportsClosedDateRouteImport } from './routes/reports.closed.$date'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsWaiterRoute = TabsWaiterRouteImport.update({
  id: '/tabs-waiter',
  path: '/tabs-waiter',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsHistoryRoute = TabsHistoryRouteImport.update({
  id: '/tabs-history',
  path: '/tabs-history',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsAdminRoute = TabsAdminRouteImport.update({
  id: '/tabs-admin',
  path: '/tabs-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const TabRoute = TabRouteImport.update({
  id: '/tab',
  path: '/tab',
  getParentRoute: () => rootRouteImport,
} as any)
const SellRoute = SellRouteImport.update({
  id: '/sell',
  path: '/sell',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ReceiptsRoute = ReceiptsRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const CashbookRoute = CashbookRouteImport.update({
  id: '/cashbook',
  path: '/cashbook',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsClosedRoute = ReportsClosedRouteImport.update({
  id: '/closed',
  path: '/closed',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsCashbookRoute = ReportsCashbookRouteImport.update({
  id: '/cashbook',
  path: '/cashbook',
  getParentRoute: () => ReportsRoute,
} as any)
const ReceiptIdRoute = ReceiptIdRouteImport.update({
  id: '/receipt/$id',
  path: '/receipt/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CashbookNewRoute = CashbookNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CashbookRoute,
} as any)
const CashbookCloseRoute = CashbookCloseRouteImport.update({
  id: '/close',
  path: '/close',
  getParentRoute: () => CashbookRoute,
} as any)
const ReportsClosedDateRoute = ReportsClosedDateRouteImport.update({
  id: '/$date',
  path: '/$date',
  getParentRoute: () => ReportsClosedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cashbook': typeof CashbookRouteWithChildren
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/receipts': typeof ReceiptsRoute
  '/reports': typeof ReportsRouteWithChildren
  '/sell': typeof SellRoute
  '/tab': typeof TabRoute
  '/tabs-admin': typeof TabsAdminRoute
  '/tabs-history': typeof TabsHistoryRoute
  '/tabs-waiter': typeof TabsWaiterRoute
  '/users': typeof UsersRoute
  '/cashbook/close': typeof CashbookCloseRoute
  '/cashbook/new': typeof CashbookNewRoute
  '/receipt/$id': typeof ReceiptIdRoute
  '/reports/cashbook': typeof ReportsCashbookRoute
  '/reports/closed': typeof ReportsClosedRouteWithChildren
  '/reports/': typeof ReportsIndexRoute
  '/reports/closed/$date': typeof ReportsClosedDateRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cashbook': typeof CashbookRouteWithChildren
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/receipts': typeof ReceiptsRoute
  '/sell': typeof SellRoute
  '/tab': typeof TabRoute
  '/tabs-admin': typeof TabsAdminRoute
  '/tabs-history': typeof TabsHistoryRoute
  '/tabs-waiter': typeof TabsWaiterRoute
  '/users': typeof UsersRoute
  '/cashbook/close': typeof CashbookCloseRoute
  '/cashbook/new': typeof CashbookNewRoute
  '/receipt/$id': typeof ReceiptIdRoute
  '/reports/cashbook': typeof ReportsCashbookRoute
  '/reports/closed': typeof ReportsClosedRouteWithChildren
  '/reports': typeof ReportsIndexRoute
  '/reports/closed/$date': typeof ReportsClosedDateRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cashbook': typeof CashbookRouteWithChildren
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/receipts': typeof ReceiptsRoute
  '/reports': typeof ReportsRouteWithChildren
  '/sell': typeof SellRoute
  '/tab': typeof TabRoute
  '/tabs-admin': typeof TabsAdminRoute
  '/tabs-history': typeof TabsHistoryRoute
  '/tabs-waiter': typeof TabsWaiterRoute
  '/users': typeof UsersRoute
  '/cashbook/close': typeof CashbookCloseRoute
  '/cashbook/new': typeof CashbookNewRoute
  '/receipt/$id': typeof ReceiptIdRoute
  '/reports/cashbook': typeof ReportsCashbookRoute
  '/reports/closed': typeof ReportsClosedRouteWithChildren
  '/reports/': typeof ReportsIndexRoute
  '/reports/closed/$date': typeof ReportsClosedDateRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cashbook'
    | '/inventory'
    | '/login'
    | '/receipts'
    | '/reports'
    | '/sell'
    | '/tab'
    | '/tabs-admin'
    | '/tabs-history'
    | '/tabs-waiter'
    | '/users'
    | '/cashbook/close'
    | '/cashbook/new'
    | '/receipt/$id'
    | '/reports/cashbook'
    | '/reports/closed'
    | '/reports/'
    | '/reports/closed/$date'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cashbook'
    | '/inventory'
    | '/login'
    | '/receipts'
    | '/sell'
    | '/tab'
    | '/tabs-admin'
    | '/tabs-history'
    | '/tabs-waiter'
    | '/users'
    | '/cashbook/close'
    | '/cashbook/new'
    | '/receipt/$id'
    | '/reports/cashbook'
    | '/reports/closed'
    | '/reports'
    | '/reports/closed/$date'
  id:
    | '__root__'
    | '/'
    | '/cashbook'
    | '/inventory'
    | '/login'
    | '/receipts'
    | '/reports'
    | '/sell'
    | '/tab'
    | '/tabs-admin'
    | '/tabs-history'
    | '/tabs-waiter'
    | '/users'
    | '/cashbook/close'
    | '/cashbook/new'
    | '/receipt/$id'
    | '/reports/cashbook'
    | '/reports/closed'
    | '/reports/'
    | '/reports/closed/$date'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CashbookRoute: typeof CashbookRouteWithChildren
  InventoryRoute: typeof InventoryRoute
  LoginRoute: typeof LoginRoute
  ReceiptsRoute: typeof ReceiptsRoute
  ReportsRoute: typeof ReportsRouteWithChildren
  SellRoute: typeof SellRoute
  TabRoute: typeof TabRoute
  TabsAdminRoute: typeof TabsAdminRoute
  TabsHistoryRoute: typeof TabsHistoryRoute
  TabsWaiterRoute: typeof TabsWaiterRoute
  UsersRoute: typeof UsersRoute
  ReceiptIdRoute: typeof ReceiptIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tabs-waiter': {
      id: '/tabs-waiter'
      path: '/tabs-waiter'
      fullPath: '/tabs-waiter'
      preLoaderRoute: typeof TabsWaiterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tabs-history': {
      id: '/tabs-history'
      path: '/tabs-history'
      fullPath: '/tabs-history'
      preLoaderRoute: typeof TabsHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tabs-admin': {
      id: '/tabs-admin'
      path: '/tabs-admin'
      fullPath: '/tabs-admin'
      preLoaderRoute: typeof TabsAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tab': {
      id: '/tab'
      path: '/tab'
      fullPath: '/tab'
      preLoaderRoute: typeof TabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sell': {
      id: '/sell'
      path: '/sell'
      fullPath: '/sell'
      preLoaderRoute: typeof SellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/receipts': {
      id: '/receipts'
      path: '/receipts'
      fullPath: '/receipts'
      preLoaderRoute: typeof ReceiptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cashbook': {
      id: '/cashbook'
      path: '/cashbook'
      fullPath: '/cashbook'
      preLoaderRoute: typeof CashbookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/closed': {
      id: '/reports/closed'
      path: '/closed'
      fullPath: '/reports/closed'
      preLoaderRoute: typeof ReportsClosedRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/cashbook': {
      id: '/reports/cashbook'
      path: '/cashbook'
      fullPath: '/reports/cashbook'
      preLoaderRoute: typeof ReportsCashbookRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/receipt/$id': {
      id: '/receipt/$id'
      path: '/receipt/$id'
      fullPath: '/receipt/$id'
      preLoaderRoute: typeof ReceiptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cashbook/new': {
      id: '/cashbook/new'
      path: '/new'
      fullPath: '/cashbook/new'
      preLoaderRoute: typeof CashbookNewRouteImport
      parentRoute: typeof CashbookRoute
    }
    '/cashbook/close': {
      id: '/cashbook/close'
      path: '/close'
      fullPath: '/cashbook/close'
      preLoaderRoute: typeof CashbookCloseRouteImport
      parentRoute: typeof CashbookRoute
    }
    '/reports/closed/$date': {
      id: '/reports/closed/$date'
      path: '/$date'
      fullPath: '/reports/closed/$date'
      preLoaderRoute: typeof ReportsClosedDateRouteImport
      parentRoute: typeof ReportsClosedRoute
    }
  }
}

interface CashbookRouteChildren {
  CashbookCloseRoute: typeof CashbookCloseRoute
  CashbookNewRoute: typeof CashbookNewRoute
}

const CashbookRouteChildren: CashbookRouteChildren = {
  CashbookCloseRoute: CashbookCloseRoute,
  CashbookNewRoute: CashbookNewRoute,
}

const CashbookRouteWithChildren = CashbookRoute._addFileChildren(
  CashbookRouteChildren,
)

interface ReportsClosedRouteChildren {
  ReportsClosedDateRoute: typeof ReportsClosedDateRoute
}

const ReportsClosedRouteChildren: ReportsClosedRouteChildren = {
  ReportsClosedDateRoute: ReportsClosedDateRoute,
}

const ReportsClosedRouteWithChildren = ReportsClosedRoute._addFileChildren(
  ReportsClosedRouteChildren,
)

interface ReportsRouteChildren {
  ReportsCashbookRoute: typeof ReportsCashbookRoute
  ReportsClosedRoute: typeof ReportsClosedRouteWithChildren
  ReportsIndexRoute: typeof ReportsIndexRoute
}

const ReportsRouteChildren: ReportsRouteChildren = {
  ReportsCashbookRoute: ReportsCashbookRoute,
  ReportsClosedRoute: ReportsClosedRouteWithChildren,
  ReportsIndexRoute: ReportsIndexRoute,
}

const ReportsRouteWithChildren =
  ReportsRoute._addFileChildren(ReportsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CashbookRoute: CashbookRouteWithChildren,
  InventoryRoute: InventoryRoute,
  LoginRoute: LoginRoute,
  ReceiptsRoute: ReceiptsRoute,
  ReportsRoute: ReportsRouteWithChildren,
  SellRoute: SellRoute,
  TabRoute: TabRoute,
  TabsAdminRoute: TabsAdminRoute,
  TabsHistoryRoute: TabsHistoryRoute,
  TabsWaiterRoute: TabsWaiterRoute,
  UsersRoute: UsersRoute,
  ReceiptIdRoute: ReceiptIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
